import React, { useState } from 'react'
import { Box, Container, Grid, Theme, useMediaQuery } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { img as imgs, img } from '../../../imgs'
import { Modal } from '../../../components'

interface ILegendItem {
  image: string
  nomination: string
  name?: string
  type: 'VIDEO' | 'COMMAND' | 'SINGLE'
  commands?: string[]
}

const LegendItem: React.FC<ILegendItem> = ({ image, name, nomination, type, commands = [] }): JSX.Element => {
  const classes = useStyles()
  const sm = useMediaQuery(({ breakpoints: { down } }: Theme) => down(600))

  const [show, setShow] = useState<boolean>(false)

  return (
    <Grid container justifyContent="center">
      <Grid item>
        <Modal maxWidth={sm ? 'sm' : 'md'} open={show} onClose={() => setShow(false)}>
          <Box width="100%" display="flex" justifyContent="center">
            <img src={image} alt="" className={classes.imgModal} />
          </Box>
          {/* {type === 'VIDEO' ? ( */}
          {/*  <> */}
          {/*    <Box className={classes.name}>Абсолютный победитель</Box> */}
          {/*    <Box className={classes.commands}> */}
          {/*      <Box mt={1} ml={2} mb={2}> */}
          {/*        Зиновьева Софья г. Новокузнецк «2 этап на лучшей территории» */}
          {/*      </Box> */}
          {/*    </Box> */}
          {/*    <Box className={classes.name}>Приз зрительских симпатий</Box> */}
          {/*    <Box className={classes.commands}> */}
          {/*      <Box mt={1} ml={2}> */}
          {/*        Вяткин Роман, Бикулов Артем KFC Мамонтов Москва «Road to Dream» */}
          {/*      </Box> */}
          {/*    </Box> */}
          {/*  </> */}
          {/* ) : ( */}
          {/*  <> */}
          <Box className={classes.name}>{name}</Box>
          <Box className={classes.commands}>
            {commands.length > 0 &&
              commands.map((i, k) => {
                return (
                  <Box key={`${i}-${k}`} mt={1} ml={2}>
                    {i}
                  </Box>
                )
              })}
          </Box>
          {/*  </> */}
          {/* )} */}
        </Modal>
        <Box className={classes.item} onClick={() => setShow(true)}>
          <Box className={classes.imgBox}>
            <img src={image} alt="" className={classes.img} />
          </Box>
          <Box className={classes.info}>
            <Box className={classes.nomination}>
              Номинация
              <Box textTransform="uppercase">«{nomination}»</Box>
            </Box>
          </Box>
        </Box>
      </Grid>
    </Grid>
  )
}

const LegendLogo: React.FC = (): JSX.Element => {
  const classes = useStyles()
  const sm = useMediaQuery(({ breakpoints: { down } }: Theme) => down(600))

  return (
    <Grid container justifyContent="center" mb={{ xs: 3, sm: 5, md: 0 }}>
      <Grid item>
        <img src={img.logoStart} alt="" className={classes.logo} />
      </Grid>
    </Grid>
  )
}

export const LegendSection: React.FC = (): JSX.Element => {
  const classes = useStyles()
  const md = useMediaQuery(({ breakpoints: { down } }: Theme) => down(960))

  return (
    <Box className={classes.page}>
      <Container className={classes.container}>
        <Box className={classes.title}>Легенды 2023</Box>
        <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
          {md && (
            <Grid item xs={12}>
              <LegendLogo />
            </Grid>
          )}
          <Grid item>
            <LegendItem type="COMMAND" image={img.car} nomination="Авто" name="" commands={['', '', '', '']} />
            <LegendItem
              type="COMMAND"
              image={img.service}
              nomination="Обслуживание"
              name=""
              commands={['', '', '', '']}
            />
          </Grid>
          {!md && (
            <Grid item>
              <LegendLogo />
            </Grid>
          )}
          <Grid item>
            <LegendItem type="SINGLE" image={img.chick} nomination="Цыпленок" name="" />
            <LegendItem type="SINGLE" image={img.kitchen} nomination="Кухня" name="" />
          </Grid>
          {/* <LegendItem type="VIDEO" image={img.video} nomination="Видеоконтест" /> */}
        </Grid>
      </Container>
      <img src={imgs.newsBottom} alt="" className={classes.legendBottom} />
    </Box>
  )
}

const useStyles = makeStyles(({ breakpoints: { down }, palette }: Theme) => ({
  page: {
    width: '100%',
    padding: '50px 0 35px',
    overflow: 'hidden',
    [down('md')]: {
      padding: '40px 0 35px',
    },
    [down('sm')]: {
      padding: '30px 0 15px',
    },
  },
  container: {
    maxWidth: '1280px!important',
    [down('lg')]: {
      padding: '0 15px!important',
    },
    [down('md')]: {
      maxWidth: '660px!important',
    },
    [down('sm')]: {
      padding: '0 10px!important',
    },
  },
  title: {
    fontSize: 44,
    fontWeight: 700,
    marginBottom: 50,
    textAlign: 'center',
    textTransform: 'uppercase',
    [down('lg')]: {
      fontSize: 40,
      marginBottom: 40,
    },
    [down('sm')]: {
      fontSize: 28,
      marginBottom: 30,
    },
  },
  item: {
    width: 260,
    cursor: 'pointer',
    [down('sm')]: {
      width: 170,
    },
  },
  imgBox: {
    borderRadius: 20,
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    width: 260,
    height: 177,
    [down('sm')]: {
      width: 170,
      height: 116,
      borderRadius: 12,
    },
  },
  img: {
    // width: 260,
    height: 177,
    [down('sm')]: {
      // width: 170,
      height: 116,
    },
  },
  logo: {
    width: 300,
    [down('md')]: {
      width: 280,
    },
    [down('sm')]: {
      width: 250,
    },
  },
  info: {
    paddingLeft: 15,
    marginTop: 10,
    [down('sm')]: {
      paddingLeft: 10,
    },
  },
  nomination: {
    fontSize: 16,
    fontWeight: 700,
    color: '#6C6C6C',
    marginBottom: 30,
    [down('sm')]: {
      fontSize: 14,
    },
  },
  name: {
    fontSize: 16,
    fontWeight: 700,
    margin: '5px 40px 0',
    [down('sm')]: {
      fontSize: 14,
    },
  },
  commands: {
    fontSize: 16,
    fontWeight: 500,
    margin: '5px 40px 0',
    [down('sm')]: {
      fontSize: 14,
      margin: '5px 20px 0',
    },
  },
  legendBottom: {
    width: '100%',
    minWidth: 1100,
    marginTop: 50,
    [down('lg')]: {
      marginTop: 20,
    },
    [down('sm')]: {
      marginTop: 0,
    },
  },
  imgModal: {
    borderRadius: 6,
    width: '100%',
    maxWidth: 710,
    margin: '50px 0 25px',
    [down('sm')]: {
      margin: '30px 0 5px',
    },
  },
}))
